export const BoxStyle = {
  mr: 1,
  width: "250px",
};

export const SimpleBoxStyle = {
  width: "170px",
};

export const menuItemLinkStyle = {
  "&:hover": {
    bg: "whiteGray",
  },
  color: "black",
  display: "block",
  fontSize: 1,
  px: 3,
  py: 2,
  textAlign: "right",
};

export const menuItemStyle = {
  px: 4,
  py: 1,
};

export const dropdownStyle = {
  minWidth: "230px",
  position: "absolute",
  right: "-10px",
  top: "45px",
};

export const buttonStyle = {
  "&:hover": {
    bg: "whiteGray",
  },
  background: "none",
  border: "none",
  borderRadius: 0,
  color: "black",
  display: "block",
  fontSize: 1,
  fontWeight: "body",
  outline: "none",
  p: 0,
  px: 3,
  py: 2,
  textAlign: "right",
  width: "100%",
};

export const separatorStyle = {
  bg: "whiteGray",
  height: "1px",
  mb: "3px",
  mt: "3px",
  width: "100%",
};
